import React, { Component } from 'react';
import { SearchResult, CharityDetailsHeading, MobileCard, TitleHeading, MobileInnerWrapper, CharityButton, ClearList } from '../style';
import { Row, Col } from 'antd';
import { DataValue, DataHeading } from "../../../../../CommonComponents/commonStyles";
import PropTypes from 'prop-types';

class AddCharityMobile extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { charityList } = this.props;

        return(
            <SearchResult data-test="addCharityMobBlock">
                <CharityDetailsHeading className="mt-30">Search results</CharityDetailsHeading>
                {
                    charityList.map((item, index) => (
                        <MobileCard key={index} className="wrapper">
                            <TitleHeading>{item.legalName}</TitleHeading>
                            <MobileInnerWrapper>
                                <Row>
                                    <Col sm={12} xs={12}>
                                        <DataHeading>
                                            Address
                                        </DataHeading>
                                        <DataValue data-test="addCharityMobDVBlock">
                                            {`${item.addressLine1 ? item.addressLine1 + ",": ""} 
                                            ${item.addressLine2 ? item.addressLine2 + ",": ""}
                                            ${item.addressLine3 ? item.addressLine3 + ",": ""}
                                            ${item.city ? item.city + ",": ""}
                                            ${item.state ? item.state + " ": ""}
                                            ${item.zip ? item.zip + ",": ""}
                                            ${item.country ? item.country: ""}`}
                                        </DataValue>
                                    </Col>
                                    <Col sm={12} xs={12}>
                                        <DataHeading>
                                            Interest Area
                                        </DataHeading>
                                        <DataValue>
                                            {item.interestArea}
                                        </DataValue>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} xs={24}>
                                        <CharityButton onClick={() => this.props.addCharity(item.granteeOrgId, item.legalName)}>Add charity</CharityButton>
                                    </Col>
                                </Row>
                            </MobileInnerWrapper>
                        </MobileCard>
                    ))
                }
                <ClearList>
                    <a onClick={() => this.props.clearList()}>Clear all</a>
                </ClearList>
            </SearchResult>
        )
    }

}

AddCharityMobile.propTypes = {
    addCharity: PropTypes.func,
    clearList: PropTypes.func,
    charityList: PropTypes.arrayOf(PropTypes.object)
}

export default AddCharityMobile;